import {CasinoSvg} from "@/app/components/icons/CasinoSvg";
import {SportSvg} from "@/app/components/icons/SportSvg";

export const MENU_TABS = [
    {
        label: 'AppAside.casino',
        value: '/',
        icon: <CasinoSvg/>
    },
    {
        label: 'AppAside.sports',
        value: '#',
        icon: <SportSvg/>
    }
]
